export default "__VITE_ASSET__d6cb63fe__"